import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "AlignLeft.svg",
  "use": "AlignLeft.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"AlignLeft.svg\"><path d=\"M14.0207,46.0207h24a2,2,0,0,1,0,4h-24a2,2,0,0,1,0-4Zm36-4h-36a2,2,0,0,1,0-4h36a2,2,0,0,1,0,4Zm-36-12h34a2,2,0,0,1,0,4h-34a2,2,0,0,1,0-4Zm0-8h28a2,2,0,1,1,0,4h-28a2,2,0,0,1,0-4Zm36-4h-36a2,2,0,1,1,0-4h36a2,2,0,1,1,0,4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol